import type { FunctionComponent } from "react";
import CampaignPostsAdminPartial from "../../../partials/admin/home/campaign-posts/campaign-posts.admin.partials";
import { PostStatus } from "../../../types/models/post.models.types";
import { useParams } from "react-router-dom";

export const CampaignLivePostsAdminScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return (
		<CampaignPostsAdminPartial
			tabs={[
				{
					status: PostStatus.postApproved,
					title: "Live Posts",
					flagged: false,
				},
				{
					status: PostStatus.flagged,
					title: "Flagged",
					flagged: true,
				},
				{
					status: PostStatus.flaggedReview,
					title: "Flagged review",
					flagged: true,
				},
				{
					status: PostStatus.disqualify,
					title: "Disqualified",
					flagged: false,
				},
			]}
			initialStatus={PostStatus.postApproved}
			campaignId={campaignId}
		/>
	);
};
